import React, { useEffect, useState } from "react";
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row } from "reactstrap";
import classnames from 'classnames';
import 'assets/css/componentStyles/tabs.css';
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";

const Tabs = ({ children = null, items, activeTab, handleTabClick, type, onlyDropdown = false, useDefaultTab=true }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    const tabClick = (tabId) => {
        handleTabClick(tabId);
        localStorage.setItem(`${type}_filter_tabs`, tabId);
    };

    const selectedIcon = items?.find(item => item.id === activeTab)?.icon;
    return (
        <Row>
            {!onlyDropdown && (
                <Col className="d-none d-sm-block">
                    <Nav tabs>
                        {items.map((label, index) => (
                            <NavItem key={label.id} style={{ height: "10mm" }}>
                                <NavLink
                                    className={classnames({ active: activeTab === label.id })}
                                    onClick={() => tabClick(label.id, index)}
                                >
                                    <IconButtonWithTooltip
                                        color={activeTab === label.id ? "#ffffff" : (label.color || "#212529")}
                                        translationId={label.label}
                                        icon={label.icon}
                                        type={label.type}
                                        size="xl"
                                    />
                                </NavLink>
                            </NavItem>
                        ))}
                        {children}
                    </Nav>
                </Col>
            )}
            <Col className={!onlyDropdown ? "d-sm-none" : "sm-12"}>
                {children}
                <Dropdown isOpen={isDropdownOpen} toggle={toggleDropdown}>
                    <DropdownToggle caret>
                        {selectedIcon && (
                            <IconButtonWithTooltip
                                color="#ffffff"
                                translationId={activeTab}
                                icon={selectedIcon}
                                type="IconOnly"
                                size="xl"
                            />
                        )}
                    </DropdownToggle>
                    <DropdownMenu>
                        {items.map((label, index) => (
                            <DropdownItem
                                key={label.id}
                                active={activeTab === label.id}
                                onClick={() => tabClick(label.id, index)}
                            >
                                <IconButtonWithTooltip
                                    color={activeTab === label.id ? "#ffffff" : "#212529"}
                                    translationId={label.label}
                                    icon={label.icon}
                                    type="IconOnly"
                                    size="xl"
                                />
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </Dropdown>
            </Col>
        </Row>
    );
};

export default Tabs;
